import type { GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import type { NavigationGeneratorResult } from '@cli-types/next-adapter/generators.js'
import { NO_NAV_SCHEMAS } from '@cli-constants/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { buildNavigationExtractSource } from '@next-adapter/generators/navigation-extract.js'
export function updateNavigation(
  schema: Schema,
  navigationDir: string,
  options: GeneratorOptions = {}
): NavigationGeneratorResult {
  if (NO_NAV_SCHEMAS.has(schema.name)) {
    return { files: [] }
  }

  const adminRoutePath = options.adminRoutePath ?? '/admin'

  const content = buildNavigationExtractSource(schema.name, {
    label: schema.label,
    href: `${adminRoutePath}/${schema.name}`,
    icon: schema.icon,
    group: schema.navGroup?.label,
    groupIcon: schema.navGroup?.icon,
    groupPosition: schema.navGroup?.position,
    position: schema.navPosition
  })

  return {
    files: [createGeneratedFile(`${navigationDir}/${schema.name}.ts`, content)]
  }
}
